module.exports = __webpack_public_path__ + "static/media/dogimage.87487218.jpg";